export default __webpack_public_path__ + "static/media/circle_checked_icon.f1237990.svg";